module.exports = __webpack_public_path__ + "static/img/duomeiti.d80079d6.png";